import { blobServices } from "./InspectionOneServices";

async function uploadFile(
  file: File,
  extension: string,
  type = 0
): Promise<{ response: any; fileUrl: string }> {
  return new Promise(async (resolve, reject) => {
    const reader = new FileReader();
    reader.onload = async (e: ProgressEvent<FileReader>) => {
      if (e.target && e.target.result) {
        try {
          // Perform the file upload operation in the background
          let binaryData: ArrayBuffer | null = e.target.result as ArrayBuffer; // Directly use the ArrayBuffer

          let fileName = file.name;
          if (type === 1) {
            const randomString = Math.random().toString(36).substring(2, 12); // 8-character alphanumeric
            const dotIndex = file.name.lastIndexOf(".");
            if (dotIndex !== -1) {
              fileName = `${file.name.substring(0, dotIndex)}_random_${randomString}${file.name.substring(dotIndex)}`;
            } else {
              fileName = `${file.name}_random_${randomString}`;
            }
          }

          // Make a call to your service function passing binaryData and extension
          const response = await blobServices.BlobStorage(
            binaryData,
            extension,
            fileName,
          );

          // Resolve the promise with the response and file URL
          resolve({ response, fileUrl: e.target.result.toString() });
        } catch (error) {
          console.error("Error uploading file:", error);
          reject(error); // Reject the promise if an error occurs
        }
      }
    };
    reader.readAsArrayBuffer(file); // Read file as ArrayBuffer
  });
}

export default uploadFile;
